import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { LogService } from '@ridango/core';

import { Angulartics2 } from 'angulartics2';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ReceiptService {

    constructor(
        @Inject('ENV') private env: any,
        private ls: LogService,
        private http: HttpClient,
        private angulartics2: Angulartics2
    ) {}

    sendToEmail(lang: string, email: string, token: string = null): Observable<any> {
        const payload = {
            token: token,
            lang: lang,
            email: email
        };
        this.angulartics2.eventTrack.next({
            action: 'download',
            properties: { category: 'pdf', label: 'from ReceiptService toEmail' },
        });
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/cart/pdf/send-to-email`;
        return this.http.post(url, payload);
    }

    getPdfSpa(lang: string, token: string): Observable<Blob> {
        const payload = {
            token: token,
            lang: lang
        };
        this.angulartics2.eventTrack.next({
            action: 'download',
            properties: { category: 'pdf', label: 'from ReceiptService' },
        });
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/cart/pdf/spa`;
        return this.http.post(url, payload, {
            responseType: 'blob'
        });
    }
}
